import React, { useEffect, useState } from 'react';
import { useThemeMode } from '../../ThemeContext';
import { dataAPI } from '../../helpers/api_service';
import { useNavigate, Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import LogoSvg from '../../assets/logo.svg';
import './TermsAndPolicy.css';

function TermsAndConditions() {
  const { mode } = useThemeMode();
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const normalizeContent = (policy) => {
      if (!policy) return '';
      if (typeof policy === 'string') return policy; // already HTML/text
      if (policy.html) return policy.html; // common key for html content
      if (policy.content) {
        // content can be string or array of paragraphs
        if (typeof policy.content === 'string') return policy.content;
        if (Array.isArray(policy.content)) {
          return policy.content.map((p) => `<p>${String(p)}</p>`).join('');
        }
        return String(policy.content);
      }
      // Fallback: pretty print JSON as pre/code block
      return `<pre style="white-space:pre-wrap;">${
        JSON.stringify(policy, null, 2)
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
      }</pre>`;
    };
    const fetchPolicies = async () => {
      try {
        setLoading(true);
        const res = await dataAPI.getPolicies();
        const termsRaw = res?.terms_and_conditions || res?.data?.terms_and_conditions || '';
        setContent(normalizeContent(termsRaw));
      } catch (e) {
        setError(e.message || 'Failed to load terms');
      } finally {
        setLoading(false);
      }
    };
    fetchPolicies();
  }, []);

  return (
    <div
      className={`policy-page ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}
      style={{ overflowX: 'hidden', overflowY: 'auto', backgroundColor: mode === 'dark' ? '#0f0f0f' : '#ffffff', minHeight: '100vh' }}
    >
      <div
        className="policy-header"
        style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: mode === 'dark' ? 'rgba(17, 17, 17, 0.9)' : 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(10px)',
        borderBottom: `1px solid ${mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`
      }}>
        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', flex: '0 0 auto' }}>
          <img src={LogoSvg} alt="Complimate Logo" style={{ height: 40, verticalAlign: 'middle' }} />
        </Link>
        <h2
          className="policy-title"
          style={{
          margin: 0,
          fontSize: '24px',
          fontWeight: 700,
          color: mode === 'dark' ? '#26C3C0' : '#009391',
          fontFamily: "'Urbanist', Arial, sans-serif",
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          whiteSpace: 'nowrap'
        }}>
          Terms & Conditions
        </h2>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '50%',
            color: mode === 'dark' ? '#FFFFFF' : '#222222',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background-color 0.2s ease',
            flex: '0 0 auto',
            marginLeft: 'auto'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = mode === 'dark' ? '#333' : '#f0f0f0';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
          }}
        >
          <CloseIcon style={{ fontSize: '24px' }} />
        </button>
      </div>

      <div className="policy-content" style={{ paddingTop: '80px', padding: 24 }}>
        <h1 style={{ color: mode === 'dark' ? '#26C3C0' : '#009391', marginBottom: 12, fontSize: 24 }}>Terms & Conditions</h1>
        {loading && <div style={{ color: mode === 'dark' ? '#ffffff' : '#222' }}>Loading...</div>}
        {error && <div style={{ color: '#f44336' }}>{error}</div>}
        {!loading && !error && (
          <div
            style={{
              color: mode === 'dark' ? '#e6e6e6' : '#333',
              lineHeight: 1.7,
              fontFamily: 'Urbanist, Arial, sans-serif'
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    </div>
  );
}

export default TermsAndConditions;


